module.exports = {"grades":{"normal":"B","awakened":"B+"},"gameplay":{"abilities":["poisonimmunity","fury"],"description":"When Attacked\n10% chance for Fury, increasing Attack by 70% for 5 seconds.\n\nPassive\nAn enhanced immune system provides full immunity to the Poisons of the Battlerealm"},"specials":{"1":{"name":"Head Smash","ranges":["melee"],"damagetypes":["physical"]},"2":{"name":"Thunderclap","ranges":["short"],"damagetypes":["physical"]},"3":{"name":"Worldbreaker","damagetypes":["physical"]}},"signature":{"name":"Hulk Rage"},"author":{"name":"JJW","type":"reddit","profile":"-JJW-"}}


//////////////////
// WEBPACK FOOTER
// ./src/data/guides/hulk.json
// module id = 466
// module chunks = 0